<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1 style="padding-bottom: 40px;">Dedication</h1>
<p>This work of art is dedicated to my loving spouse, Stella Jane, who has supported me throughout this endeavour. It is also dedicated to my loving family, Dane, Jing, Kai, Ariana, Dane Gaius and Rodger. Without their unfailing support this would not have been possible.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?cff46a40